module.exports = __webpack_public_path__ + "static/media/1005547.1b296f29.png";